import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

import { THROUGHPUT_SERIES, type PeriodPick } from './types';

// Período abierto en el detalle de Documentos por período (G1-7), en la URL
// (UX-NAV-02): `periodo=<serie>:<período>`. Volver de la ficha reabre el diálogo. Un
// valor mal formado se ignora; que el período esté en el gráfico lo decide la tarjeta.

const PARAM = 'periodo';
const VALUE = /^(started|completed):(\d{4}(?:-\d{2}(?:-\d{2})?)?)$/;

export function parsePeriodPick(raw: string | null): PeriodPick | null {
  const m = raw === null ? null : VALUE.exec(raw);
  const series = THROUGHPUT_SERIES.find((s) => s === m?.[1]);
  return m?.[2] === undefined || series === undefined ? null : { series, period: m[2] };
}

export function usePeriodParam(): [PeriodPick | null, (pick: PeriodPick | null) => void] {
  const [params, setParams] = useSearchParams();
  const set = useCallback(
    (pick: PeriodPick | null) =>
      setParams(
        (prev) => {
          const p = new URLSearchParams(prev);
          if (pick === null) {
            p.delete(PARAM);
          } else {
            p.set(PARAM, `${pick.series}:${pick.period}`);
          }
          return p;
        },
        { replace: true },
      ),
    [setParams],
  );
  return [parsePeriodPick(params.get(PARAM)), set];
}
